import { Google, Pixall } from '../analytics/index.js';
import { sanitizeValue } from './helpers/index.js';
export async function seoLinkClick(metadata, option) {
  if (metadata === void 0) {
    metadata = {};
  }
  const {
    data = {},
    dataLayer = {}
  } = metadata;
  const {
    page = {},
    catalog = 'atc'
  } = dataLayer;
  const {
    makeCode,
    modelCode,
    linkItem,
    section = {}
  } = data;
  let gaData = null;
  let pixallData = null;
  let pageType;
  const eventNonInteractive = false;
  const getLocationFromUrl = url => url && url.match(/[^/]+$/) ? url.match(/[^/]+$/)[0].replace(/\+/g, '-').toLowerCase() : '';
  switch (page?.pageType) {
    case 'homepage':
      pageType = 'homepage';
      break;
    case 'slp_new':
      pageType = 'slp_new';
      break;
    case 'slp_used':
      pageType = 'slp_used';
      break;
    case 'slp_cpo':
      pageType = 'slp_cpo';
      break;
    case 'slp_cat':
      pageType = 'slp_cat';
      break;
    case 'CONDITION':
      pageType = 'CONDITION';
      break;
    default:
      pageType = '';
      break;
  }
  if (pageType) {
    pixallData = {
      eventType: 'click',
      eventSource: 'link',
      hasListingType: false
    };
    switch (section.type) {
      case 'POPULAR_MODEL_SERIES':
        {
          gaData = {
            eventElement: 'search-car',
            eventData: {
              vehicle: {
                catalog,
                makeId: makeCode,
                makeName: linkItem?.makeName,
                modelId: modelCode,
                modelName: linkItem?.modelName,
                condition: linkItem?.listingType?.toLowerCase() || ''
              }
            }
          };
          if (section.styleCode) {
            gaData.eventData.vehicle.bodyStyle = section.styleCode;
          }
          if (section.listingType.toLowerCase() === 'used') {
            gaData.eventResult = `text-link::srp::used-${sanitizeValue(makeCode)}-${sanitizeValue(modelCode)}`;
            pixallData.label = `text-link::srp::used-${sanitizeValue(makeCode)}-${sanitizeValue(modelCode)}`;
          }
          if (section.listingType.toLowerCase() === 'new') {
            gaData.eventResult = `text-link::srp::new-${sanitizeValue(makeCode)}-${sanitizeValue(modelCode)}`;
            pixallData.label = `text-link::srp::new-${sanitizeValue(makeCode)}-${sanitizeValue(modelCode)}`;
          }
          if (section.listingType.toLowerCase() === 'certified') {
            pixallData.label = `text-link::srp::certified-${sanitizeValue(makeCode)}-${sanitizeValue(modelCode)}`;
          }
          break;
        }
      case 'POPULAR_CATEGORY_SERIES':
        {
          gaData = {
            eventElement: 'search-car',
            eventResult: `text-link::srp::${sanitizeValue(linkItem.label)}`
          };
          break;
        }
      case 'PRICE':
        {
          const price = linkItem?.maxPrice;
          gaData = {
            eventResult: `text-link::srp::${sanitizeValue(linkItem.label)}`,
            eventElement: 'search-car',
            eventData: {
              vehicle: {
                catalog,
                price: price && price > 0 ? price.toString() : undefined
              }
            }
          };
          if (section.styleCode) {
            gaData.eventData.vehicle.bodyStyle = section.styleCode;
          }
          break;
        }
      case 'RESEARCH':
        {
          gaData = {
            eventResult: 'text-link::article::car-research-and-advice',
            eventElement: 'editorial'
          };
          break;
        }
      case 'LOCATION':
        {
          pixallData.label = `text-link::srp::${getLocationFromUrl(linkItem?.href)}`;
          break;
        }
      default:
        break;
    }
  }
  if (gaData) {
    Google.sendClickEvent({
      ...gaData,
      eventNonInteractive
    }, option);
  }
  if (pixallData && pixallData.label) {
    Pixall.sendClickEvent(pixallData, dataLayer, option);
  }
  return {};
}
export default {
  seoLinkClick
};